//https://stackoverflow.com/questions/2698725/comparing-date-part-only-without-comparing-time-in-javascript
export const justADate = (initDate?: string | Date): Date => {
  // if no date supplied, use Now.
  if (!initDate) initDate = new Date();

  // if initDate specifies a timezone offset, or is already UTC, just keep the date part, reflecting the date _in that timezone_
  if (
    typeof initDate === 'string' &&
    initDate.match(/([+-]\d{2}:\d{2}|Z)$/gm)
  ) {
    return new Date(`${initDate.substring(0, 10)}T00:00:00Z`);
  }

  // if init date is not already a date object, feed it to the date constructor.
  if (!(initDate instanceof Date)) initDate = new Date(initDate);

  // Vital Step! Strip time part. Create UTC midnight dateObj according to local timezone.
  return new Date(
    Date.UTC(initDate.getFullYear(), initDate.getMonth(), initDate.getDate()),
  );
};

// convert string like 2020-01-01T00:00:00Z to 2020-01-01T00:00:00
// ISO format with 'Z' will be interpreted by Date as needed to convert to
// local time. See issue with FormDatePicker
export const convertToLocalDateStr = (date?: Date | string): string => {
  if (date instanceof Date) return date.toISOString().replace('Z', '');

  if (typeof date === 'string' && date.match(/^\d{4}-[01]\d-[0123]\d/g)) {
    // start with xxxx-xx-xx
    if (date.match(/([+-]\d{2}:\d{2}|Z)$/gm)) {
      // end with +/-00:00 or Z
      return date.replace(/([+-]\d{2}:\d{2}|Z)$/gm, '');
    }

    if (date.match(/00$/gm)) {
      // end with 00
      return date;
    }

    return `${date.substring(0, 10)}T00:00:00.000`;
  }
  return '';
};
